import { render, staticRenderFns } from "./HistoryTagsSelection.vue?vue&type=template&id=70fa5d03&scoped=true&"
import script from "./HistoryTagsSelection.vue?vue&type=script&lang=ts&"
export * from "./HistoryTagsSelection.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryTagsSelection.vue?vue&type=style&index=0&id=70fa5d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa5d03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem,VListItemContent,VListItemTitle})
